import React, { useState } from 'react';

const MessageManagement = () => {
    const [smsCount, setSmsCount] = useState(1000);
    const [allowSms, setAllowSms] = useState(false);
    const [smsQueueChecked, setSmsQueueChecked] = useState(false);
    const [remindHoursChecked, setRemindHoursChecked] = useState(false);
    const [remindDaysChecked, setRemindDaysChecked] = useState(false);
    const [confirmationSms, setConfirmationSms] = useState(false);
    const [generalChecked, setGeneralChecked] = useState(false);
    const [smsQueue, setSmsQueue] = useState(3);
    const [remindHours, setRemindHours] = useState(3);
    const [remindDays, setRemindDays] = useState(3);
    const [messageTemplates, setMessageTemplates] = useState([]);
    const [smsQueueMessage, setSmsQueueMessage] = useState('');
    const [reminderMessage, setReminderMessage] = useState('');
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [remindDaysMessage, setRemindDaysMessage] = useState('');
    const [generalMessage, setGeneralMessage] = useState('');
    const [frequency, setFrequency] = useState('one-time');
    const [dayOfWeek, setDayOfWeek] = useState('ראשון');
    const [dayOfMonth, setDayOfMonth] = useState(1);
    const [targetAudience, setTargetAudience] = useState('all');

    const handleAddTemplate = (type, message, frequency, audience) => {
        setMessageTemplates([...messageTemplates, { type, message, frequency, audience }]);
        if (type === 'smsQueue') setSmsQueueMessage('');
        else if (type === 'reminder') setReminderMessage('');
        else if (type === 'reminderDays') setRemindDaysMessage('');
        else if (type === 'confirmation') setConfirmationMessage('');
        else setGeneralMessage('');
    };

    const handleRemoveTemplate = (index) => {
        setMessageTemplates(messageTemplates.filter((_, i) => i !== index));
    };

    const hasTemplates = (type) => {
        return messageTemplates.some(template => template.type === type);
    };

    return (
        <div>
            <h3 className='message-title'>ניהול הודעות</h3>
            <div className='sms-count-display'>
                <strong>{smsCount}</strong> כמות SMS זמינים
            </div>
            <div className={`input-container allow-sms-input`}>
                <label>
                    <input
                        type='checkbox'
                        checked={allowSms}
                        onChange={(e) => setAllowSms(e.target.checked)}
                        className='allow-sms-switch'
                    />
                    1. אפשר שליחת SMS ללקוח
                </label>
            </div>
            <div className={`input-container sms-queue-input ${smsQueueChecked ? 'active' : ''}`}>
                <label>
                    <input
                        type='checkbox'
                        checked={smsQueueChecked}
                        onChange={(e) => setSmsQueueChecked(e.target.checked)}
                        className='sms-queue-checkbox'
                    />
                    2. שלח SMS ללקוח כאשר לפניו
                    <input
                        type='number'
                        value={smsQueue}
                        onChange={(e) => setSmsQueue(Number(e.target.value))}
                        min='1'
                        className='sms-queue-number'
                    />
                    אנשים בתור
                </label>
            </div>
            {smsQueueChecked && (
                <div className={`message-template-input ${hasTemplates('smsQueue') ? '' : 'active'}`}>
                    <label>
                        נוסח הודעה:
                        <input
                            type='text'
                            id='smsQueueMessage'
                            value={smsQueueMessage}
                            onChange={(e) => setSmsQueueMessage(e.target.value)}
                            className='template-message-input sms-queue-message-input'
                            style={{ width: '300px' }}
                        />
                    </label>
                    <button type='button' className='add-template-button' onClick={() => handleAddTemplate('smsQueue', smsQueueMessage, `${smsQueue} אנשים בתור`)}>+</button>
                </div>
            )}
            {smsQueueChecked && (
                <div className='template-preview'>
                    {messageTemplates.filter(template => template.type === 'smsQueue').map((template, index) => (
                        <div key={index} className='template-tag'>
                            נוסח הודעה: {template.message} (תדירות: {template.frequency})
                            <button type='button' className='remove-template-button' onClick={() => handleRemoveTemplate(index)}>x</button>
                        </div>
                    ))}
                </div>
            )}
            <div className={`input-container remind-hours-input ${remindHoursChecked ? 'active' : ''}`}>
                <label>
                    <input
                        type='checkbox'
                        checked={remindHoursChecked}
                        onChange={(e) => setRemindHoursChecked(e.target.checked)}
                        className='remind-hours-checkbox'
                    />
                    3. תזכר לקוח
                    <input
                        type='number'
                        value={remindHours}
                        onChange={(e) => setRemindHours(Number(e.target.value))}
                        min='1'
                        className='remind-hours-number'
                    />
                    שעות לפני התור
                </label>
            </div>
            {remindHoursChecked && (
                <div className={`message-template-input ${hasTemplates('reminder') ? '' : 'active'}`}>
                    <label>
                        נוסח הודעה:
                        <input
                            type='text'
                            id='remindHoursMessage'
                            value={reminderMessage}
                            onChange={(e) => setReminderMessage(e.target.value)}
                            className='template-message-input remind-hours-message-input'
                            style={{ width: '300px' }}
                        />
                    </label>
                    <button type='button' className='add-template-button' onClick={() => handleAddTemplate('reminder', reminderMessage, `${remindHours} שעות`)}>+</button>
                </div>
            )}
            {remindHoursChecked && (
                <div className='template-preview'>
                    {messageTemplates.filter(template => template.type === 'reminder').map((template, index) => (
                        <div key={index} className='template-tag'>
                            נוסח הודעה: {template.message} (תדירות: {template.frequency})
                            <button type='button' className='remove-template-button' onClick={() => handleRemoveTemplate(index)}>x</button>
                        </div>
                    ))}
                </div>
            )}
            <div className={`input-container remind-days-input ${remindDaysChecked ? 'active' : ''}`}>
                <label>
                    <input
                        type='checkbox'
                        checked={remindDaysChecked}
                        onChange={(e) => setRemindDaysChecked(e.target.checked)}
                        className='remind-days-checkbox'
                    />
                    4. תזכר לקוח
                    <input
                        type='number'
                        value={remindDays}
                        onChange={(e) => setRemindDays(Number(e.target.value))}
                        min='1'
                        className='remind-days-number'
                    />
                    ימים לפני התור
                </label>
            </div>
            {remindDaysChecked && (
                <div className={`message-template-input ${hasTemplates('reminderDays') ? '' : 'active'}`}>
                    <label>
                        נוסח הודעה:
                        <input
                            type='text'
                            id='remindDaysMessage'
                            value={remindDaysMessage}
                            onChange={(e) => setRemindDaysMessage(e.target.value)}
                            className='template-message-input remind-days-message-input'
                            style={{ width: '300px' }}
                        />
                    </label>
                    <button type='button' className='add-template-button' onClick={() => handleAddTemplate('reminderDays', remindDaysMessage, `${remindDays} ימים`)}>+</button>
                </div>
            )}
            {remindDaysChecked && (
                <div className='template-preview'>
                    {messageTemplates.filter(template => template.type === 'reminderDays').map((template, index) => (
                        <div key={index} className='template-tag'>
                            נוסח הודעה: {template.message} (תדירות: {template.frequency})
                            <button type='button' className='remove-template-button' onClick={() => handleRemoveTemplate(index)}>x</button>
                        </div>
                    ))}
                </div>
            )}
            <div className={`input-container confirmation-sms-input ${confirmationSms ? 'active' : ''}`}>
                <label>
                    <input
                        type='checkbox'
                        checked={confirmationSms}
                        onChange={(e) => setConfirmationSms(e.target.checked)}
                        className='confirmation-sms-checkbox'
                    />
                    5. שלח SMS אישור לאחר שמירת הזמנה
                </label>
            </div>
            {confirmationSms && (
                <div className={`message-template-input ${hasTemplates('confirmation') ? '' : 'active'}`}>
                    <label>
                        נוסח הודעה:
                        <input
                            type='text'
                            id='confirmationMessage'
                            value={confirmationMessage}
                            onChange={(e) => setConfirmationMessage(e.target.value)}
                            className='template-message-input confirmation-message-input'
                            style={{ width: '300px' }}
                        />
                    </label>
                    <button type='button' className='add-template-button' onClick={() => handleAddTemplate('confirmation', confirmationMessage, 'אישור')}>+</button>
                </div>
            )}
            {confirmationSms && (
                <div className='template-preview'>
                    {messageTemplates.filter(template => template.type === 'confirmation').map((template, index) => (
                        <div key={index} className='template-tag'>
                            נוסח הודעה: {template.message} (תדירות: {template.frequency})
                            <button type='button' className='remove-template-button' onClick={() => handleRemoveTemplate(index)}>x</button>
                        </div>
                    ))}
                </div>
            )}
            <div className={`input-container general-message-input ${generalChecked ? 'active' : ''}`}>
                <label>
                    <input
                        type='checkbox'
                        checked={generalChecked}
                        onChange={(e) => setGeneralChecked(e.target.checked)}
                        className='general-message-checkbox'
                    />
                    6. הודעה כללית:
                    <select value={frequency} onChange={(e) => setFrequency(e.target.value)} className='frequency-select'>
                        <option value='one-time'>חד פעמי</option>
                        <option value='weekly'>פעם בשבוע</option>
                        <option value='monthly'>פעם בחודש</option>
                    </select>
                    {frequency === 'weekly' && (
                        <select value={dayOfWeek} onChange={(e) => setDayOfWeek(e.target.value)} className='day-of-week-select'>
                            <option value='ראשון'>ראשון</option>
                            <option value='שני'>שני</option>
                            <option value='שלישי'>שלישי</option>
                            <option value='רביעי'>רביעי</option>
                            <option value='חמישי'>חמישי</option>
                            <option value='שישי'>שישי</option>
                            <option value='שבת'>שבת</option>
                        </select>
                    )}
                    {frequency === 'monthly' && (
                        <select value={dayOfMonth} onChange={(e) => setDayOfMonth(Number(e.target.value))} className='day-of-month-select'>
                            {Array.from({ length: 31 }, (_, i) => (
                                <option key={i + 1} value={i + 1}>{i + 1}</option>
                            ))}
                        </select>
                    )}
                    <select value={targetAudience} onChange={(e) => setTargetAudience(e.target.value)} className='target-audience-select'>
                        <option value='all'>כל הלקוחות</option>
                        <option value='inactive'>לקוחות לא פעילים</option>
                        <option value='active'>לקוחות פעילים</option>
                    </select>
                </label>
            </div>
            {generalChecked && (
                <div className={`message-template-input ${hasTemplates('general') ? '' : 'active'}`}>
                    <label>
                        נוסח הודעה:
                        <input
                            type='text'
                            id='generalMessage'
                            value={generalMessage}
                            onChange={(e) => setGeneralMessage(e.target.value)}
                            className='template-message-input general-message-input'
                            style={{ width: '300px' }}
                        />
                    </label>
                    <button type='button' className='add-template-button' onClick={() => handleAddTemplate('general', generalMessage, frequency, targetAudience)}>+</button>
                </div>
            )}
            {generalChecked && (
                <div className='template-preview'>
                    {messageTemplates.filter(template => template.type === 'general').map((template, index) => (
                        <div key={index} className='template-tag'>
                            נוסח הודעה: {template.message} (תדירות: {template.frequency}, קהל יעד: {template.audience})
                            <button type='button' className='remove-template-button' onClick={() => handleRemoveTemplate(index)}>x</button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MessageManagement;
